
import React, { useState ,useEffect} from 'react';
import {useNavigate } from 'react-router-dom';
import {Row, Table} from 'antd';
import Title from 'antd/es/skeleton/Title';
import { viewSalesDetailsBasedOnStatus} from '../service/UserDetails';
import { render } from '@testing-library/react';
import Item from 'antd/es/list/Item';
import App from '../App';
import moment from 'moment';
import {Divider} from 'antd';


function DNC(){
    const navigator = useNavigate();

    const [user, setUser] = useState({ role: 'sales',});

  

    const handleClick = (record) => {
      const url = `/sales-lead/${record.id}?isEdit=true`;
    localStorage.setItem('isEdit', true);
      window.open(url, '_blank');
    };

  

    // const loadMasterData = async () => {
    //     const response =await masterSource();
    //     const meterOpt = [];
    //     response.data.meter_types.map(item=>  meterOpt.push({label: item.meter_type,value: item.id}))
    //     setMeterTypeOption(meterOpt);
        
    //  }
const [dataSource, setDataSource]= useState([]) 



const callBackResponse = async () => {
  const status =5;
        
  await viewSalesDetailsBasedOnStatus(status)
  .then(res => 
   {
       
       const mappedData = res.data.data;
       
       setDataSource(mappedData);
   })
  .catch(err => 
   {
       
       if(err.response.data.error === "No leads found with the provided filters"){
           
       }
   })
} 

useEffect(()=>{

    callBackResponse();

  },[]);

  const columns =[
    {
      title: 'Lead ID',
      dataIndex: 'id',
      width: 100,
      render: (id, record) => (
        <span
          style={{ cursor: 'pointer', color: 'blue', textDecoration: 'underline' }} // Optional styling
          onClick={() => handleClick(record)} // Call handleClick directly
        >
          {id}
        </span>
      )
    },
    {
       // key:'lead_date',
        title : 'Lead Date',
       // dataIndex : 'lead_date',
       render: (record) => { return (<p>{moment.utc(record.attributes.created_at).format("DD-MM-YYYY")}</p>)},
      // render: (record) => record.attributes.created_at,
        width: 150
    },
	   {
      title : 'Distribution Date',
      width: 150,
      render: (record) => { return (<p>{record.attributes.distributed_on ? moment(record.attributes.distributed_on).format("DD-MM-YYYY"): ""}</p>)},
      
    },
    {
      //  key: 'attributes.business_name',
        title : 'Business Name',
       // dataIndex :'attributes.business_name',
        width: 150,
        render: (record) => record.attributes.business_name
        //render: business_name => business_name,
    },
    {
      //  key:'customer_name',
        title : 'Customer Name',
        //dataIndex : 'customer_name',
        render: (record) => record.attributes.customer_name,
        width: 150
    },
    {
       // key:'billing_address',
        title : 'Billing Address',
      //  dataIndex : 'billing_address',
      render: (record) => record.attributes.billing_address,
        width: 150,
    },
    {
      //  key:'billing_postcode',
        title : 'Billing Postcode',
        render: (record) => record.attributes.billing_postcode,
      //  dataIndex : 'billing_postcode',
        width: 150,
    },
    {
       // key:'contact_number',
        title : 'Contact Number',
        render: (record) => record.attributes.contact_number,
      //  dataIndex : 'contact_number',
        width: 150,
    },
    {
       // key:'email_address',
        title : 'Email Address',
        render: (record) => record.attributes.email_address,
       // dataIndex : 'email_address',
        width: 150,
    },
    {
       // key:'product_id',
        title : 'Product',
       // dataIndex : 'product_id', 
       render:(record) => {
        // Check the product_id and return the corresponding text
        return record.attributes.product_id === 1 ? "Electricity" : "Gas";
      },
       //render: (record) => {if(record.attributes.product_id ===1){"Electricity"}else{"Gas"}},
        width: 150
    },
    {
        //key:'elec_current_supplier',
        title : 'Elec Current Supplier',
     //   dataIndex : 'elec_current_supplier',
        render: (record) => record.relations.supplier.electricity.name,
        width: 150
    },
    {
      // key:'elec_account_number',
       title : 'Elec Account Number',
       render: (record) => record.attributes.electricity.account_number,
       //dataIndex : 'elec_account_number',
       width: 150
   },
   {
    // key:'elec_supply_number',
     title : 'Supply Number',
    // dataIndex : 'elec_supply_number',
    render: (record) => {
     if(record.attributes.electricity.supply_number){
     const supplyNumber = record.attributes.electricity.supply_number;

     // Assuming supplyNumber is a string of 21 characters (8 + 13)
     const formattedSupplyNumber = `${supplyNumber.slice(0, 8)} ${supplyNumber.slice(8)}`;

     return formattedSupplyNumber;
   }
   },
     width: 170
 },
 {
  //  key:'elec_msn',

    title : 'Electric MSN',
    render: (record) => record.attributes.electricity.msn,
    width: 150
   // dataIndex : 'elec_msn'
},
{
  //key:'elec_contract_end_date',
  title : 'Electric Contract End Date',
  render: (record) => record.attributes.electricity.contract_end_date,
 // dataIndex : 'elec_contract_end_date',
  width: 150
},
{
  //key:'elec_eac',
  title : 'Electric EAC',
  render: (record) => record.attributes.electricity.eac,
  //dataIndex : 'elec_eac',
  width: 150
},
{
  //key:'gas_billing_amount',
  title : 'Electric Billing Amount',
  render: (record) => record.attributes.electricity.billing_amount,
 // dataIndex : 'elec_billing_amount',
  width: 150
},
{
//key:'gas_billing_amount',
title : 'Electric Billing Frequncy',
render: (record) => record.attributes.electricity.billing_frequency,
// dataIndex : 'elec_billing_amount',
width: 150
},
{
  //key:'gas_metertype',
  title : 'Electricity Meter type',
  //dataIndex : 'gas_metertype',
 render: (record) => record.relations.meter_type.electricity.name,
  width: 150
},
{
  //key:'gas_standing_charge',
  title : 'Electric Standing Charge',
  render: (record) => record.attributes.electricity.standing_charge,
 // dataIndex : 'gas_standing_charge',
  width: 150
},

{
  // key:'gas_unit_rate',
   title : 'Electric Unit Rate',
   render: (record) => record.attributes.electricity.unit_rate,
   //dataIndex : 'gas_unit_rate',
   width: 150
},
{
 // key:'elec_night_rate',
  title : 'Night Rate',
  render: (record) => record.attributes.electricity.night_rate,
  //dataIndex : 'elec_night_rate',
  width: 150
},
{
  //key:'elec_eve_weekend',
  title : 'Eve Weekend',
  render: (record) => record.attributes.electricity.eve_weekend,
  //dataIndex : 'elec_eve_weekend',
  width: 150
},
{
//  key:'elec_capacity_charge',
  title : 'Capacity Charge',
  render: (record) => record.attributes.electricity.capacity_charge,
//  dataIndex : 'elec_capacity_charge',
  width: 150
},
{
//  key:'elec_fit_charge',
  title : 'FIT Charge',
  render: (record) => record.attributes.electricity.fit_charge,
 // dataIndex : 'elec_fit_charge',
  width: 150
},
    {
        //key:'elec_current_supplier',
        title : 'Gas Current Supplier',
     //   dataIndex : 'elec_current_supplier',
        render: (record) => record.relations.supplier.gas.name,
        width: 150
    },
    {
        // key:'elec_account_number',
         title : 'Gas Account Number',
         render: (record) => record.attributes.gas.account_number,
         //dataIndex : 'elec_account_number',
         width: 150
     },
   
    
    {
      //  key:'gas_mpr',
        title : 'MPR Number',
        render: (record) => record.attributes.gas.mpr,
        //dataIndex : 'gas_mpr',
        width: 150
    },
    
    {
      //  key:'gas_msn',
        title : 'Gas MSN',
        render: (record) => record.attributes.gas.msn,
      //  dataIndex : 'gas_msn',
        width: 150
    },
    
    {
      //  key:'gas_contract_end_date',
        title : 'Gas Contract End Date',
        render: (record) => record.attributes.gas.contract_end_date,
      //  dataIndex : 'gas_contract_end_date',
        width: 150
    },
    
    {
        //key:'gas_eac',
        title : 'Gas EAC',
        render: (record) => record.attributes.gas.eac,
        //dataIndex : 'gas_eac',
        width: 150
    },
      
  {
   // key:'gas_billing_amount',
    title : 'Gas Billing Amount',
  //  dataIndex : 'gas_billing_amount',
  render: (record) => record.attributes.gas.billing_amount,
    width: 150
},

{
    //key:'gas_metertype',
    title : 'Gas Meter type',
    //dataIndex : 'gas_metertype',
    render: (record) => record.relations.meter_type.gas.name,
    width: 150
},

{
    //key:'gas_standing_charge',
    title : 'Gas Standing Charge',
    render: (record) => record.attributes.gas.standing_charge,
   // dataIndex : 'gas_standing_charge',
    width: 150
},

{
   // key:'gas_unit_rate',
    title : 'Gas Unit Rate',
    render: (record) => record.attributes.gas.unit_rate,
    //dataIndex : 'gas_unit_rate',
    width: 150
},
{
  //  key:'lead_status_list_id',
    title : 'Lead Status',
    render: (record) => record.relations.lead_status.name,
 //   dataIndex : 'lead_status_list_id',
    width: 150
},
{
  //  key:'lead_status_list_id',
    title : 'Sales Lead Status',
    render: (record) => record.relations.sales_status.name,
 //   dataIndex : 'lead_status_list_id',
    width: 150
},
{
  //  key:'lead_status_list_id',
    title : 'Call Back Date',
    render: (record) => { return (<p>{record.attributes.callback_date?moment(record.attributes.callback_date).format("DD-MM-YYYY"):""}</p>)},
 //   dataIndex : 'lead_status_list_id',
    width: 150
},

// {
//     //key:'agent_feedback',
//     title : 'Agent Feedback',
//     dataIndex : (record) => record.attributes.lead_status_list_id,
//     width: 150
// }
// {
//   title: 'Agent Feedback',
//   key: 'agent_feedback',
//   dataIndex: 'attributes', // Still keep dataIndex to refer to the main object
//   width: 150,
//  render: (_, record) => record.attributes?.survey_feedback || ''
// }

]
    return(
    <div className='callbacktable'>
         <Divider variant="dotted" style={{ borderColor: '#7cb305' }}>DNC details for Sales Leads</Divider>
        <header className='callbacktable-header'>
            {/* {
                <p>dataSource: {[dataSource]}</p>
            } */}
       <Table columns={columns}
       bordered
      // title={() => 'All leads Data For Admin'}
        dataSource={dataSource
        //    dataSource.map((curData) => {
        //    const {agent_id} = curData;
        //    const {business_name,billing_address} = curData.attributes;
           
        //    })
        }
       scroll={{ y: 500 }}
       pagination={{ pageSize: 100 }}
       onRow={(record, rowIndex) => {
        return {
        
          handleClick: event => {
             handleClick(record);
          }, 
         
        };
      }}
      >
       </Table>
        </header>
    </div>
    );
}

export default DNC;